import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { Observable } from 'rxjs/Observable';
import { Project } from '../models/Project';
import { accountFromLocalStorage } from '../../../../../old-crazy-web-frontend/src/app/utils/account-from-localstorage';

@Injectable()
export class CrazyCallConfigService {
  constructor(private http: HttpClient, private appConfigService: AppConfigService) {}

  get authToken(): string {
    const token = localStorage.getItem('ngStorage-authToken');
    return token ? token.replace(/\"/g, '') : '';
  }

  get account(): string {
    const account = accountFromLocalStorage();
    return account ? account.replace(/\"/g, '') : this.appConfigService.APP_ID;
  }

  get appId() {
    return this.account;
  }

  getProjects(): Observable<Project[]> {
    return this.http.get<Project[]>(`/projects`);
  }
}
